<template>

</template>

<script>
import {defineComponent} from 'vue';

export default defineComponent({
  name: 'GoogleAnalytics',
  created() {
    if (import.meta.env.VITE_APP_ENV === 'local') {
      return;
    }

    // Initialize dataLayer and gtag function first
    window.dataLayer = window.dataLayer || [];
    function gtag(){window.dataLayer.push(arguments);}
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', 'G-J0Y0G2KQ3K');
    gtag('config', 'G-8589LV4CC6');

    // Load Google Analytics script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-J0Y0G2KQ3K';
    document.head.appendChild(script);
  },
})
</script>

<style scoped lang="scss">

</style>
